import { createPayload, updatePayload, type PayloadSpec } from '../../../lib/forms/payload.js';

export const TAX_PAYLOAD_SPEC: PayloadSpec = {
  required: [
    'name',
    'type',
    'basis',
    'rate',
    'amount',
    'inclusive',
    'compounds',
    'appliesToFees',
    'enabled',
  ],
  optional: [],
  numeric: ['priority'],
  createOnly: ['propertyId'],
};

export function buildCreateTaxPayload(values: Record<string, unknown>): Record<string, unknown> {
  return createPayload(values, TAX_PAYLOAD_SPEC);
}

export function buildUpdateTaxPayload(
  values: Record<string, unknown>,
  version: number,
): Record<string, unknown> {
  return updatePayload(values, TAX_PAYLOAD_SPEC, version);
}
